import { useEffect } from "react";

export const SITE_URL = "https://coveragewithjacqueline.com";
export const OG_IMAGE = `${SITE_URL}/images/og-image.jpg`;
const BRAND = "Coverage with Jacqueline";

const LOCAL_KEYWORDS = [
  "ACA enrollment prince george's county", "health insurance help maryland", "insurance agent upper marlboro md", "health coverage college park md", "health insurance greenbelt md", "insurance landover md", "ACA plans oxon hill md", "affordable health insurance PG county maryland", "ACA marketplace help prince george's county",
];

const ACA_KEYWORDS = [
  "maryland ACA health insurance", "ACA marketplace plans maryland", "ACA enrollment prince george's county", "health insurance help maryland",
  "affordable health insurance PG county maryland", "ACA marketplace help prince george's county", "health insurance college park md",
  "health insurance greenbelt md", "ACA plans oxon hill md", "insurance landover md", "insurance agent upper marlboro md",
  "health coverage college park md", "licensed insurance agent prince george's county", "maryland health connection enrollment help",
];

const kw = (...extra) => [...extra, ...LOCAL_KEYWORDS].join(", ");

export const PAGES = {
  home: {
    path: "/",
    title: "Coverage with Jacqueline | Maryland ACA Health Insurance",
    description: "Personalized health insurance guidance for Maryland individuals and families. Explore ACA Marketplace plans, coverage options, and enrollment assistance.",
    keywords: ACA_KEYWORDS.join(", "),
  },
  "aca-open-enrollment-explained": {
    path: "/guides/aca-open-enrollment-explained",
    title: "ACA Health Insurance for Prince George's County, MD | Coverage with Jacqueline",
    description: "Prince George's County has the highest uninsured rate in Maryland — over 73,000 residents without coverage. ACA Marketplace plans may cost less than you think. Free enrollment help from a licensed agent serving PG County and surrounding areas.",
    keywords: kw("ACA marketplace PG county", "affordable health insurance prince george's county", "ACA enrollment maryland", "do I qualify for ACA", "how much does ACA cost"),
    type: "article",
  },
  privacy: {
    path: "/privacy",
    title: `Privacy Policy | ${BRAND}`,
    description: "How Coverage with Jacqueline collects, uses and protects your personal information when you request ACA health insurance help in Maryland.",
    keywords: kw("privacy policy", "health insurance agent maryland"),
  },
  terms: {
    path: "/terms",
    title: `Terms of Use | ${BRAND}`,
    description: "Terms of use for coveragewithjacqueline.com, the website of a licensed Maryland health insurance agent offering free ACA Marketplace guidance.",
    keywords: kw("terms of use", "health insurance agent maryland"),
  },
};

export const articleSeo = (slug, article) =>
  PAGES[slug] || {
    path: `/guides/${slug}`,
    title: article ? `${article.title} | ${BRAND}` : `Health Insurance Guides | ${BRAND}`,
    description: article?.excerpt || PAGES.home.description,
    keywords: kw(article?.category || "health insurance guide"),
    type: "article",
  };

export const HOME_JSON_LD = {
  "@context": "https://schema.org",
  "@type": "InsuranceAgency",
  name: BRAND,
  description: "Licensed health insurance agent serving Prince George's County and surrounding Maryland communities. Personalized help exploring ACA Marketplace health insurance options for individuals and families.",
  areaServed: ["Prince George's County, MD", "Upper Marlboro, MD", "Bowie, MD", "Laurel, MD", "College Park, MD", "Hyattsville, MD",
    "Greenbelt, MD", "Landover, MD", "Oxon Hill, MD", "Capitol Heights, MD", "District Heights, MD", "Bladensburg, MD",
    "Riverdale Park, MD", "Charles County, MD", "Calvert County, MD"],
  serviceType: ["ACA Marketplace Plans", "Health Insurance Consultation", "Enrollment Assistance", "Dental and Vision Insurance"],
  email: "info@coveragewithjacqueline.com",
  telephone: "+1-202-413-2343",
  url: SITE_URL,
  image: OG_IMAGE,
};

function upsert(selector, make, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) { el = make(); document.head.appendChild(el); }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
}
const meta = (name, content, attr = "name") =>
  upsert(`meta[${attr}="${name}"]`, () => document.createElement("meta"), { [attr]: name, content });

export function useSeo({ title, description, keywords, path, type = "website", jsonLd, noindex }) {
  useEffect(() => {
    const url = `${SITE_URL}${path}`;
    document.title = title;
    meta("description", description);
    if (keywords) meta("keywords", keywords);
    meta("robots", noindex ? "noindex, nofollow" : "index, follow");
    upsert('link[rel="canonical"]', () => document.createElement("link"), { rel: "canonical", href: url });
    meta("og:title", title, "property");
    meta("og:description", description, "property");
    meta("og:image", OG_IMAGE, "property");
    meta("og:url", url, "property");
    meta("og:type", type, "property");
    meta("og:site_name", BRAND, "property");
    meta("twitter:card", "summary_large_image");
    meta("twitter:title", title);
    meta("twitter:description", description);
    meta("twitter:image", OG_IMAGE);
    let script = document.getElementById("ld-json");
    if (jsonLd) {
      if (!script) { script = document.createElement("script"); script.id = "ld-json"; script.type = "application/ld+json"; document.head.appendChild(script); }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }
  }, [title, description, keywords, path, type, jsonLd, noindex]);
}
